import { render, staticRenderFns } from "./InvoiceReceiverForm.vue?vue&type=template&id=01a86a5e"
import script from "./InvoiceReceiverForm.vue?vue&type=script&lang=ts"
export * from "./InvoiceReceiverForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports